import { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  TimeUtil,
  DaySelector,
  VibeButton,
  viCopy,
  viTrash,
} from 'vibeguide';
import './MusicOverrideToolbar.scss';

function MusicOverrideToolbar({
  className = '',
  day,
  onCopyToDays = () => {},
  onClearDay = () => {},
}) {
  const [showCopyDay, setShowCopyDay] = useState(false);
  const [copyToDays, setCopyToDays] = useState([]);

  const dayIndex = TimeUtil.getDayOfWeekIndex(day);
  const dayText = TimeUtil.getDayFromIndex(dayIndex, 'dddd');

  const onToggleCopyDay = () => {
    setShowCopyDay(!showCopyDay);

    if (!showCopyDay) {
      setCopyToDays([]);
    }
  };

  const onClickSaveCopyDays = () => {
    onCopyToDays(copyToDays);
    onToggleCopyDay();
  };

  const onChangeCopyDays = (copyDays) => {
    setCopyToDays(copyDays);
  };

  return (
    <div className={classNames('MusicOverrideToolbar', className)}>
      <div className="day">
        {dayText}
      </div>

      <div className="copy-day">
        <VibeButton
          className="btn-toolbar btn-copy-day"
          text="Copy Day"
          variant="outlined"
          color="secondary"
          icon={viCopy}
          testId="music-override-copy-day-button"
          onClick={onToggleCopyDay}
        />

        {showCopyDay ? (
          <div className="copy-day-details-container">
            <div className="copy-day-details">
              <div className="copy-to-text">
                Copy To...
              </div>

              <DaySelector
                toggleAll
                selectedDays={copyToDays}
                onChange={onChangeCopyDays}
              />

              <div className="actions-copy-days">
                <VibeButton
                  className="btn-cancel"
                  text="Cancel"
                  variant="outlined"
                  color="secondary"
                  testId="music-override-copy-day-cancel-button"
                  onClick={onToggleCopyDay}
                />

                <VibeButton
                  text="Save"
                  color="secondary"
                  disabled={copyToDays.length <= 0}
                  testId="music-override-copy-day-save-button"
                  onClick={onClickSaveCopyDays}
                />
              </div>
            </div>
          </div>
        ) : null}
      </div>

      <VibeButton
        className="btn-toolbar btn-clear-day"
        text="Clear Day"
        variant="outlined"
        color="secondary"
        icon={viTrash}
        testId="music-override-clear-day-button"
        onClick={onClearDay}
      />
    </div>
  );
}

MusicOverrideToolbar.propTypes = {
  className: PropTypes.string,
  day: PropTypes.string.isRequired,
  onCopyToDays: PropTypes.func,
  onClearDay: PropTypes.func,
};

export default MusicOverrideToolbar;
